import React from "react"

import classNames from "classnames"

import { times } from "shared/lib/times"
import { Chip, ChipVariant } from "shared/ui/chip/Chip"

interface LoadingTagsProps {
  amount?: number
  className?: string
  chipStyle?: ChipVariant
}

export const LoadingTags = React.memo(
  ({
    amount = 3,
    chipStyle = ChipVariant.TAG,
    className
  }: LoadingTagsProps) => (
    <div className={classNames("tags loading", className)}>
      {times(amount, index => (
        <Chip key={index} isLoading variant={chipStyle || ChipVariant.TAG} />
      ))}
    </div>
  )
)
